import React, { useEffect, useCallback } from "react";
import "./ScreenModal.css";

interface ScreenModalProps {
  src: string;
  isOpen: boolean;
  onClose: () => void;
}

const ScreenModal: React.FC<ScreenModalProps> = ({ src, isOpen, onClose }) => {
  const handleKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    },
    [onClose]
  );

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
      document.addEventListener("keydown", handleKeyDown);
    }
    return () => {
      document.body.style.overflow = "";
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [isOpen, handleKeyDown]);

  if (!isOpen) return null;

  return (
    <div className="screen-modal open">
      <div className="modal-backdrop" onClick={onClose} />
      <div className="modal-body">
        <button className="modal-close-btn" onClick={onClose}>
          <span className="material-icons">close</span>
        </button>
        <iframe
          title="Screen Preview"
          src={src}
          scrolling="no"
          style={{ width: "100%", height: "100%", border: 0, background: "#f6f6f8" }}
        />
      </div>
    </div>
  );
};

export default ScreenModal;
